<template>
  <div class="about">
    <title-banner :imgType="12" :isProductDetail="false"></title-banner>
    <div class="about-con">
      <div class="about-con-tab">
        <div class="about-con-tab-">
          <div class="about-con-tab-item" @click="$router.push({ path: '/about#synopsis' })" :class="!tabActive || tabActive === '#synopsis' ? 'about-con-tab-item-active' : ''">博为简介</div>
          <div class="about-con-tab-item" @click="$router.push({ path: '/about#culture' })" :class="tabActive === '#culture' ? 'about-con-tab-item-active' : ''">企业文化</div>
          <div class="about-con-tab-item" @click="$router.push({ path: '/about#organization' })" :class="tabActive === '#organization' ? 'about-con-tab-item-active' : ''">组织架构</div>
          <div class="about-con-tab-item" @click="$router.push({ path: '/about#honor' })" :class="tabActive === '#honor' ? 'about-con-tab-item-active' : ''">资质荣誉</div>
          <div class="about-con-tab-item" @click="$router.push({ path: '/about#contact' })" :class="tabActive === '#contact' ? 'about-con-tab-item-active' : ''">联系我们</div>
        </div>
      </div>
      <div class="about-con-body">
        <!--关于我们 #synopsis-->
        <synopsis v-if="!tabActive || tabActive === '#synopsis'"></synopsis>
        <!--企业文化 #culture-->
        <culture v-if="tabActive === '#culture'"></culture>
        <!--组织架构 #organization-->
        <organization v-if="tabActive === '#organization'"></organization>
        <!--资质荣誉 #honor-->
        <honor v-if="tabActive === '#honor'"></honor>
        <!--联系我们 #contact-->
        <contacts v-if="tabActive === '#contact'"></contacts>
      </div>
    </div>
  </div>
</template>

<script>
import titleBanner from "@/components/titleBanner/index.vue";
import synopsis from "@/views/about/components/synopsis.vue";
import culture from "@/views/about/components/culture.vue";
import organization from "@/views/about/components/organization.vue";
import honor from "@/views/about/components/honor.vue";
import contacts from "@/views/about/components/contact.vue";

export default {
  name: "contact",
  components: {
    titleBanner,
    synopsis,
    culture,
    organization,
    honor,
    contacts
  },
  data() {
    return {
      tabActive: ''
    };
  },
  created() {
    const hash = this.$route.hash;
    this.tabActive = hash ? hash : ''
  },
  watch: {
    $route(to, from) {
      if (to.path == '/about') {
        const hash = this.$route.hash;
        this.tabActive = hash ? hash : ''
      }
    }
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.about {

  &-con {

    background: #F7F7F7;
    &-tab {
      width: 100%;
      height: 55px;
      line-height: 55px;
      border-bottom: 1px solid #E4E4E4;

      &- {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        &item {
          margin-right: 40px;
          font-weight: bold;
          font-size: 16px;
          color: #898989;
          cursor: pointer;
          &-active {
            color: #222222;
            position: relative;
          }
          &-active:before {
            content: '';
            display: block;
            position: absolute;
            width: 100%;
            height: 3px;
            background: #1277E4;
            left: 0;
            bottom: -2px;
          }
        }

        &item:hover {
          opacity: .75;
        }
      }
    }
    &-body {
      width: 1200px;
      margin: 0 auto;
      padding: 30px 0;
    }
  }
}
</style>
